import { Component, Input, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { AuthService } from '@app/core/auth/auth.service';
import { SpinnerService } from '@app/core/spinner/spinner.service';
import { InfoService } from '@app/core/info/info.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { AbstractEntityComponent } from '../AbstractEntityComponent';
import { EntityInterface } from '@app/shared/model/entity/interfaces/entityInterface.model';
import { Group } from '@app/shared/model/entity/group.model';

@Component({
  selector: 'app-group-selector',
  templateUrl: './app-group-selector.component.html',
  styleUrls: ['./app-group-selector.component.scss']
})
export class AppGroupSelectorComponent extends AbstractEntityComponent implements AfterViewInit {

  @ViewChild('availableGroupsSelect') availableGroupsSelect: ElementRef;
  @ViewChild('entityGroupsSelect') entityGroupsSelect: ElementRef;

  @Input() entityInitialGroups: Array<any>;
  @Input() action: string;
  @Input() entityName: string;
  // @Input() entityGroupService: AppAbstractGroupService;
  @Input() entity: any;

  @Input() entityGroups: Array<any> = [];
  @Input() availableGroups: Array<any> = [];

  public availableGroupsSelected: Array<any> = [];
  public entityGroupsSelected: Array<any> = [];

  isAvailableGroupsSelect = false;
  isEntityGroupsSelect = false;


  constructor(
    public authService: AuthService,
    public spinner: SpinnerService,
    public infoService: InfoService,
    public modalService: NgbModal,
    public translateService: TranslateService
  ) {
    super(authService, spinner, infoService, modalService, translateService);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onCreate(entityName: string, entity: EntityInterface): void {
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onFindAll(entityName: string, entities: EntityInterface[]): void {
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getDetailComponentClass(entityName: string): any {
    return null;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getDetailModalSize(entityName: string): 'sm' | 'lg' | 'xl' {
    return 'lg';
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onInsert(entityName: string, entity: EntityInterface): void {
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onUpdate(entityName: string, entity: EntityInterface): void {
  }

  isAvailableGroupsSelected(): boolean {
    return this.availableGroupsSelected.length > 0 ? true : false;
  }
  isEntityGroupsSelected(): boolean {
    return this.entityGroupsSelected.length > 0 ? true : false;
  }

  add(): void {
    for (const group of this.availableGroupsSelected) {
      this.entityGroups.push(group);
      // this.entityGroupsSelected.push(group);
      // this.isEntityGroupsSelect = true;
      const index = this.availableGroups.findIndex((groupToRemove: Group) => groupToRemove.id === group.id);
      if (index !== -1) {
        this.availableGroups.splice(index, 1);
      }
      this.availableGroupsSelected = [];
    }
  }

  remove(): void {
    for (const group of this.entityGroupsSelected) {
      this.availableGroups.push(group);
      // this.availableGroupsSelected.push(group);
      // this.isAvailableGroupsSelect = true;

      const index = this.entityGroups.findIndex((groupToRemove: Group) => groupToRemove.id === group.id);
      if (index !== -1) {
        this.entityGroups.splice(index, 1);
      }

      this.entityGroupsSelected = [];

    }
    /* if (this.entityGroups.length !== 0) {
      this.entityGroupsSelected.push(this.entityGroups[0]);
    } else {
      this.isEntityGroupsSelect = false;
    }*/

  }

  // addAll(): void { }
  // removeAll(): void { }
  // availableGroupsChange(h: any): void { }
  // entityGroupsChange(): void { }
  changeTab(): void {
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onDelete(entityName: string, pk: EntityInterface): void {
  }
  onInit(): void {
  }
  ngAfterViewInit(): void {
  }

}
